// @need-translate
import {t} from '../../../common/getTranslations';
import {aggregateAndSendLog} from '../../../logging/aggregateAndSendLog';
import {LOG_CLICK_EVENT} from '../../../logging/logEvent';
import {putTiaraObjectProps} from '../../../logging/putTiaraObjectProps';
import {ButtonV2Variant} from '../../atoms/ButtonV2/ButtonV2.enum';
import {Dialog} from '../Dialog';

export interface TicketAskReopenCauseExpiredDialogProps {
  isMobile: boolean;
  productId: number; // for logging
  nonstopWatching?: boolean; // for loggin
  onClickCancel: () => void;
  onClickConfirm: () => void;
  isShortsDrama?: boolean;
}

export function TicketAskReopenCauseExpiredDialog({
  isMobile,
  productId,
  nonstopWatching,
  onClickCancel,
  onClickConfirm,
  isShortsDrama,
}: TicketAskReopenCauseExpiredDialogProps) {
  return (
    <Dialog
      isOpen={true}
      onClose={onClickCancel}
      isMobile={isMobile}
      isUsingScrollBlock={false}
      {...putTiaraObjectProps({
        click: {
          layer1: '대여기간만료팝업',
          imp_id: 'popup',
          imp_provider: 'service',
        },
        viewimp_contents: {
          layer1: '대여기간만료팝업',
          imp_id: 'popup',
          imp_provider: 'service',
          imp_type: 'vimp',
        },
        customProps: {
          popup_type: '대여기간만료팝업',
          event_episode_id: String(productId),
          ...(nonstopWatching !== undefined
            ? {
                viewer_mode: nonstopWatching ? '정주행모드' : '일반모드',
              }
            : {}),
          ...(isShortsDrama && {
            is_shortdrama: isShortsDrama ? 'y' : undefined,
          }),
        },
      })}
      onInView={target => {
        aggregateAndSendLog({
          targetElem: target as HTMLElement,
          actionType: 'ViewImp',
          actionName: '팝업_노출',
          customProps: {
            user_action: 'imp',
          },
        });
      }}
    >
      <Dialog.Dimmed />
      <Dialog.Title>{t('contenthome_rental_expired_popup_title')}</Dialog.Title>
      <Dialog.List>
        <Dialog.Label>
          {t('contenthome_ep_rental_expired_popup_message')}
        </Dialog.Label>
      </Dialog.List>
      <Dialog.BottomCombination>
        <Dialog.Button
          onClick={e =>
            LOG_CLICK_EVENT('대여기간만료팝업_취소_클릭', e, onClickCancel)
          }
        >
          {t('common_cancel_button')}
        </Dialog.Button>
        <Dialog.Button
          onClick={e =>
            LOG_CLICK_EVENT('대여기간만료팝업_확인_클릭', e, onClickConfirm)
          }
          variant={ButtonV2Variant.Primary}
        >
          {t('common_confirm_button')}
        </Dialog.Button>
      </Dialog.BottomCombination>
    </Dialog>
  );
}
